import type React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from '@heroui/react';
import { CartPanelView } from './CartPanelView';
import { useCartPanel } from './useCartPanel';

/**
 * Right pane: the cart. `useCartPanel` owns its state, keyboard layer,
 * dialogs and shortcuts; `CartPanelView` renders it. This section only
 * turns the hook's notice keys into toasts, and HOLD — a CTA until its flow
 * lands — into a "coming soon" one.
 */
export const CartPanel: React.FC = () => {
    const { t } = useTranslation('pages');
    const cart = useCartPanel({
        onNotice: (notice) => toast.danger(t(notice.key, notice.values)),
    });

    return (
        <CartPanelView
            {...cart}
            onHold={() =>
                toast.info(t('seller.hold'), {
                    description: t('seller.comingSoon'),
                })
            }
        />
    );
};
